const PREMIUM_RIGHTS = new Set(['can-read-premium']);

let user = null;

/**
 * Get the connected user.
 *
 * To avoid repeated calls, the same promise is returned for each call.
 * @returns {Promise<object | false>}
 */
export function getUser() {
  if (user !== null) {
    return user;
  }

  user = fetch('/wp-json/studiometa-frisbii/user')
    .then((res) => res.json())
    .catch((error) => {
      console.log(error);
    });

  return user;
}

/**
 * User is connected?
 * @returns {Promise<boolean>}
 */
export async function userIsConnected() {
  return !!(await getUser());
}

/**
 * User is premium?
 * @returns {Promise<boolean>}
 */
export async function userIsPremium() {
  const user = await getUser();
  return user && user.accessRights.find((access) => PREMIUM_RIGHTS.has(access));
}
